// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import useApi from "../../../core/customhook/useApi";
// import SnipperLoader from "../../../core/common/loader/SnipperLoader";
// import { apibaseurl, getPersonalDetails } from "../../../environment";

// /* ----------------------------------------------------------------------- */
// /*  Small building blocks                                                   */
// /* ----------------------------------------------------------------------- */

// const IMG_FALLBACK =
//   "data:image/svg+xml;utf8," +
//   encodeURIComponent(
//     `<svg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'>
//       <rect width='400' height='300' fill='#f1f2f7'/>
//       <g fill='none' stroke='#b4b9c9' stroke-width='6' stroke-linecap='round' stroke-linejoin='round'>
//         <rect x='150' y='105' width='100' height='80' rx='10'/>
//         <circle cx='185' cy='135' r='9'/>
//         <path d='M155 178l32-28 22 18 16-12 25 22'/>
//       </g>
//       <text x='200' y='225' text-anchor='middle' font-family='sans-serif' font-size='16' fill='#9aa0b4'>Image not available</text>
//     </svg>`,
//   );

// const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
//   const img = e.currentTarget;
//   if (img.src !== IMG_FALLBACK) {
//     img.onerror = null;
//     img.src = IMG_FALLBACK;
//   }
// };

// const Field: React.FC<{ icon?: string; label: string; value?: string }> = ({
//   icon,
//   label,
//   value,
// }) =>
//   !value ? null : (
//     <div className="av-field">
//       {icon && (
//         <span className="av-field-icon">
//           <i className={`ti ${icon}`}></i>
//         </span>
//       )}
//       <div className="av-field-text">
//         <span className="av-field-label">{label}</span>
//         <span className="av-field-value">{value}</span>
//       </div>
//     </div>
//   );

// const SectionHeader: React.FC<{
//   icon: string;
//   title: string;
//   subtitle?: string;
// }> = ({ icon, title, subtitle }) => (
//   <div className="av-section-head">
//     <div className="av-step">
//       <i className={`ti ${icon}`}></i>
//     </div>
//     <div>
//       <h3 className="av-section-title">{title}</h3>
//       {subtitle && <p className="av-section-subtitle">{subtitle}</p>}
//     </div>
//   </div>
// );

// const AddressSubmittedForm: React.FC = () => {
//   const reduxDashboardData = useSelector(
//     (state: any) => state?.dashboard?.dashboardData,
//   );

//   const candidateId = reduxDashboardData?.assignmentDetails?.candidate_id;

//   const getAddressAPI = useApi<any>(
//     `/api/v1/candidates/addresses/${candidateId}`,
//     {
//       method: "GET",
//       autoCall: false,
//       handleGlobalError: false,
//     },
//   );

//   const PersonalDetailAPI = useApi<any>(getPersonalDetails, {
//     method: "GET",
//     autoCall: false,
//     handleGlobalError: false,
//   });

//   const [summaryData, setSummaryData] = useState<any>(null);
//   const [personalData, setPersonalData] = useState<any>(null);

//   const fetchDetails = async () => {
//     try {
//       const res = await getAddressAPI.callApi();

//       if (!res?.success) return;
//       setSummaryData(res.data[0]);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const fetchPersonalDetails = async () => {
//     try {
//       const res = await PersonalDetailAPI.callApi();

//       if (!res?.success) return;
//       setPersonalData(res.data);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     if (candidateId) {
//       fetchDetails();
//     }
//     fetchPersonalDetails();
//   }, [candidateId]);

//   const mapSrc = `https://maps.google.com/maps?q=${summaryData?.address_latitude},${summaryData?.address_longitude}&z=15&output=embed`;

//   const live_selfie_url = `${apibaseurl}${summaryData?.live_selfie_url}`;
//   const id_proof_photo = `${apibaseurl}${summaryData?.id_proof_photo}`;
//   const address_proof_photo = `${apibaseurl}${summaryData?.address_proof_photo}`;
//   const house_photo = `${apibaseurl}${summaryData?.house_photo}`;
//   const locality_photo = `${apibaseurl}${summaryData?.locality_photo}`;

//   const loading = getAddressAPI.loading;

//   /* ---- display-only helpers (no effect on data flow) ---- */
//   const fullName = [
//     personalData?.first_name,
//     personalData?.middle_name,
//     personalData?.last_name,
//   ]
//     .filter(Boolean)
//     .join(" ");

//   const fullAddress = [
//     summaryData?.address_line1,
//     summaryData?.address_line2,
//     summaryData?.address_line3,
//     summaryData?.city,
//     summaryData?.state,
//     summaryData?.pincode,
//     summaryData?.country,
//   ]
//     .filter(Boolean)
//     .join(", ");

//   const documents = [
//     {
//       label: "ID proof",
//       hint: "Government issued identity",
//       icon: "ti-id",
//       src: id_proof_photo,
//     },
//     {
//       label: "Address proof",
//       hint: "Document showing your address",
//       icon: "ti-file-certificate",
//       src: address_proof_photo,
//     },
//     {
//       label: "House photo",
//       hint: "Front view of the house",
//       icon: "ti-home-2",
//       src: house_photo,
//     },
//     {
//       label: "Locality photo",
//       hint: "Street or neighbourhood",
//       icon: "ti-building-community",
//       src: locality_photo,
//     },
//   ];

//   return (
//     <div className="page-wrapper">
//       <div className="content">
//         {loading ? (
//           <SnipperLoader />
//         ) : (
//           <div className="av-card">
//             {/* ---------------------------- Hero ---------------------------- */}
//             <div className="av-hero">
//               <div className="av-hero-main">
//                 <div className="av-avatar">
//                   <img
//                     src={live_selfie_url}
//                     alt="Candidate selfie"
//                     onError={handleImgError}
//                   />
//                 </div>
//                 <div className="av-hero-text">
//                   <span className="av-eyebrow">
//                     <i className="ti ti-shield-check"></i>
//                     Verification report
//                   </span>
//                   <h2 className="av-title">Address Verification Summary</h2>
//                   <p className="av-hero-sub">
//                     {fullName ? (
//                       <>
//                         Submitted by <strong>{fullName}</strong>
//                       </>
//                     ) : (
//                       "Details submitted for verification"
//                     )}
//                   </p>
//                 </div>
//               </div>

//               <div className="av-status">
//                 <i className="ti ti-circle-check"></i>
//                 Submitted
//               </div>
//             </div>

//             {/* ------------------------- Quick facts ------------------------- */}
//             <div className="av-facts">
//               <div className="av-fact">
//                 <i className="ti ti-home"></i>
//                 <div>
//                   <span className="av-fact-label">Address type</span>
//                   <span className="av-fact-value">
//                     {summaryData?.address_type || "-"}
//                   </span>
//                 </div>
//               </div>
//               <div className="av-fact">
//                 <i className="ti ti-map-pin"></i>
//                 <div>
//                   <span className="av-fact-label">Location</span>
//                   <span className="av-fact-value">
//                     {[summaryData?.city, summaryData?.state]
//                       .filter(Boolean)
//                       .join(", ") || "-"}
//                   </span>
//                 </div>
//               </div>
//               <div className="av-fact">
//                 <i className="ti ti-calendar-time"></i>
//                 <div>
//                   <span className="av-fact-label">Period of stay</span>
//                   <span className="av-fact-value">
//                     {summaryData?.period_of_stay
//                       ? `${summaryData?.period_of_stay} ${summaryData?.period_of_stay_param || ""}`
//                       : "-"}
//                   </span>
//                 </div>
//               </div>
//               <div className="av-fact">
//                 <i className="ti ti-key"></i>
//                 <div>
//                   <span className="av-fact-label">Ownership</span>
//                   <span className="av-fact-value">
//                     {summaryData?.ownership_status || "-"}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             <div className="av-body">
//               {/* Personal + Address side by side */}
//               <div className="av-two-col">
//                 {/* Personal Details */}
//                 <section className="av-block">
//                   <SectionHeader
//                     icon="ti-user"
//                     title="Personal details"
//                     subtitle="Identity information as submitted"
//                   />
//                   <div className="av-grid av-grid-2">
//                     <Field
//                       icon="ti-user"
//                       label="First name"
//                       value={personalData?.first_name || "-"}
//                     />
//                     <Field
//                       icon="ti-user"
//                       label="Middle name"
//                       value={personalData?.middle_name || "-"}
//                     />
//                     <Field
//                       icon="ti-user"
//                       label="Last name"
//                       value={personalData?.last_name || "-"}
//                     />
//                     <Field
//                       icon="ti-cake"
//                       label="Date of birth"
//                       value={
//                         personalData?.dob
//                           ? new Date(personalData.dob).toLocaleDateString(
//                               "en-GB",
//                               {
//                                 day: "2-digit",
//                                 month: "short",
//                                 year: "numeric",
//                               },
//                             )
//                           : "-"
//                       }
//                     />
//                     <Field
//                       icon="ti-gender-bigender"
//                       label="Gender"
//                       value={personalData?.gender || "-"}
//                     />
//                     <Field
//                       icon="ti-users"
//                       label="Father's or Mother's name"
//                       value={personalData?.father_or_mother_name || "-"}
//                     />
//                     <Field
//                       icon="ti-phone"
//                       label="Mobile"
//                       value={personalData?.phone || "-"}
//                     />
//                     <Field
//                       icon="ti-phone-plus"
//                       label="Alternate mobile"
//                       value={personalData?.alternative_phone || "-"}
//                     />
//                     <div className="av-span-2">
//                       <Field
//                         icon="ti-mail"
//                         label="Email"
//                         value={personalData?.email || "-"}
//                       />
//                     </div>
//                   </div>
//                 </section>

//                 {/* Address Details */}
//                 <section className="av-block">
//                   <SectionHeader
//                     icon="ti-map-pin"
//                     title="Address details"
//                     subtitle="Registered residential address"
//                   />

//                   {fullAddress && (
//                     <div className="av-address-note">
//                       <i className="ti ti-map-pin-filled"></i>
//                       <p>{fullAddress}</p>
//                     </div>
//                   )}

//                   <div className="av-grid av-grid-2">
//                     <Field
//                       icon="ti-home"
//                       label="Address type"
//                       value={summaryData?.address_type}
//                     />
//                     <Field
//                       icon="ti-mailbox"
//                       label="Pincode"
//                       value={summaryData?.pincode}
//                     />
//                     <Field
//                       icon="ti-building"
//                       label="City"
//                       value={summaryData?.city}
//                     />
//                     <Field
//                       icon="ti-map"
//                       label="State"
//                       value={summaryData?.state}
//                     />
//                     <Field
//                       icon="ti-world"
//                       label="Country"
//                       value={summaryData?.country}
//                     />
//                     <Field
//                       icon="ti-door"
//                       label="House no."
//                       value={summaryData?.address_line1}
//                     />
//                     <Field
//                       icon="ti-building-skyscraper"
//                       label="Apartment"
//                       value={summaryData?.address_line2}
//                     />
//                     <Field
//                       icon="ti-flag"
//                       label="Landmark"
//                       value={summaryData?.address_line3}
//                     />
//                   </div>
//                 </section>
//               </div>

//               {/* Location + Selfie */}
//               <section className="av-block av-block-wide">
//                 <SectionHeader
//                   icon="ti-map-2"
//                   title="Location & live selfie"
//                   subtitle="Geo-tagged coordinates captured during the visit"
//                 />
//                 <div className="av-loc-grid">
//                   <div className="av-media-card">
//                     <div className="av-media-head">
//                       <span>
//                         <i className="ti ti-map"></i> Google Map
//                       </span>
//                       <a
//                         className="av-link"
//                         href={`https://www.google.com/maps?q=${summaryData?.address_latitude},${summaryData?.address_longitude}`}
//                         target="_blank"
//                         rel="noreferrer"
//                       >
//                         Open in Maps
//                       </a>
//                     </div>
//                     <div className="av-map-frame">
//                       <iframe
//                         title="location-map"
//                         src={mapSrc}
//                         loading="lazy"
//                         allowFullScreen
//                       />
//                     </div>
//                     <div className="av-coords">
//                       <span>
//                         <i className="ti ti-map-pin"></i> Lat:{" "}
//                         {summaryData?.address_latitude}
//                       </span>
//                       <span>
//                         <i className="ti ti-map-pin"></i> Long:{" "}
//                         {summaryData?.address_longitude}
//                       </span>
//                     </div>
//                   </div>

//                   <div className="av-media-card">
//                     <div className="av-media-head">
//                       <span>
//                         <i className="ti ti-camera-selfie"></i> Live selfie
//                       </span>
//                     </div>
//                     <div className="av-selfie-frame">
//                       <img
//                         src={live_selfie_url}
//                         alt="Live selfie verification"
//                         onError={handleImgError}
//                       />
//                       <span className="av-live-tag">
//                         <i className="ti ti-point-filled"></i> Captured live
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </section>

//               {/* Stay Verification */}
//               <section className="av-block av-block-wide">
//                 <SectionHeader
//                   icon="ti-home-check"
//                   title="Stay verification"
//                   subtitle="Confirmed by an on-ground verifier"
//                 />
//                 <div className="av-grid av-grid-3">
//                   <Field
//                     icon="ti-user-check"
//                     label="Verifier name"
//                     value={summaryData?.verifier_full_name}
//                   />
//                   <Field
//                     icon="ti-users-group"
//                     label="Verifier relationship"
//                     value={summaryData?.verifier_relationship}
//                   />
//                   <Field
//                     icon="ti-map-pin-cog"
//                     label="Nearest landmark"
//                     value={summaryData?.verifier_addrlandmark}
//                   />
//                   <Field
//                     icon="ti-building-community"
//                     label="Nature of address"
//                     value={summaryData?.address_type}
//                   />
//                   <Field
//                     icon="ti-calendar-time"
//                     label="Period of stay"
//                     value={`${summaryData?.period_of_stay}, ${summaryData?.period_of_stay_param}`}
//                   />
//                   <Field
//                     icon="ti-key"
//                     label="Ownership status"
//                     value={summaryData?.ownership_status}
//                   />
//                 </div>
//               </section>

//               {/* Uploaded Documents */}
//               <section className="av-block av-block-wide av-block-last">
//                 <SectionHeader
//                   icon="ti-folder"
//                   title="Uploaded documents"
//                   subtitle="Select a document to open it in a new tab"
//                 />
//                 <div className="av-doc-grid">
//                   {documents.map((doc) => (
//                     <a
//                       key={doc.label}
//                       className="av-doc-card"
//                       href={doc.src}
//                       target="_blank"
//                       rel="noreferrer"
//                     >
//                       <div className="av-doc-thumb">
//                         <img
//                           src={doc.src}
//                           alt={doc.label}
//                           className="av-doc-img"
//                           onError={handleImgError}
//                         />
//                         <span className="av-doc-overlay">
//                           <span className="av-doc-view">
//                             <i className="ti ti-eye"></i> View
//                           </span>
//                         </span>
//                       </div>
//                       <div className="av-doc-meta">
//                         <span className="av-doc-icon">
//                           <i className={`ti ${doc.icon}`}></i>
//                         </span>
//                         <div className="av-doc-text">
//                           <span className="av-doc-name">{doc.label}</span>
//                           <span className="av-doc-hint">{doc.hint}</span>
//                         </div>
//                         <i className="ti ti-external-link av-doc-ext"></i>
//                       </div>
//                     </a>
//                   ))}
//                 </div>
//               </section>
//             </div>
//           </div>
//         )}
//       </div>

//       <style>{`
//         .av-card {
//           --av-ink: #141826;
//           --av-muted: #6b7280;
//           --av-paper: #ffffff;
//           --av-canvas: #f6f7fb;
//           --av-border: #e6e8f0;
//           --av-accent: #F26522;
//           --av-accent-dark: #d4530f;
//           --av-accent-soft: #fdece2;
//           --av-success: #0f9d63;
//           --av-success-soft: #e4f7ee;
//           font-family: 'Inter', -apple-system, sans-serif;
//           color: var(--av-ink);
//           background: var(--av-paper);
//           border: 1px solid var(--av-border);
//           border-radius: 20px;
//           overflow: hidden;
//           box-shadow: 0 1px 2px rgba(20, 24, 38, 0.04), 0 16px 40px -20px rgba(20, 24, 38, 0.18);
//         }

//         /* ---------- Hero ---------- */
//         .av-hero {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           gap: 20px;
//           padding: 32px 40px 64px;
//           background: #171b2d;
//           color: #fff;
//           position: relative;
//         }

//         .av-hero::after {
//           content: '';
//           position: absolute;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           height: 4px;
//           background: var(--av-accent);
//         }

//         .av-hero-main {
//           display: flex;
//           align-items: center;
//           gap: 20px;
//           min-width: 0;
//         }

//         .av-avatar {
//           flex-shrink: 0;
//           width: 84px;
//           height: 84px;
//           border-radius: 50%;
//           padding: 3px;
//           background: var(--av-accent);
//         }

//         .av-avatar img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           border-radius: 50%;
//           border: 3px solid #171b2d;
//           background: #2a2f47;
//           display: block;
//         }

//         .av-eyebrow {
//           display: inline-flex;
//           align-items: center;
//           gap: 6px;
//           font-size: 12.5px;
//           font-weight: 600;
//           color: #ffb488;
//           margin-bottom: 6px;
//         }

//         .av-title {
//           font-size: 26px;
//           line-height: 1.2;
//           font-weight: 700;
//           margin: 0 0 6px;
//           color: #fff;
//         }

//         .av-hero-sub {
//           margin: 0;
//           font-size: 14px;
//           color: #c3c8dc;
//         }

//         .av-hero-sub strong {
//           color: #fff;
//           font-weight: 600;
//         }

//         .av-status {
//           flex-shrink: 0;
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           padding: 9px 16px;
//           border-radius: 999px;
//           font-size: 13.5px;
//           font-weight: 600;
//           color: #7be3b4;
//           background: rgba(15, 157, 99, 0.16);
//           border: 1px solid rgba(123, 227, 180, 0.35);
//         }

//         .av-status i { font-size: 18px; }

//         /* ---------- Quick facts ---------- */
//         .av-facts {
//           display: grid;
//           grid-template-columns: repeat(4, 1fr);
//           margin: -36px 40px 0;
//           position: relative;
//           z-index: 2;
//           background: var(--av-paper);
//           border: 1px solid var(--av-border);
//           border-radius: 16px;
//           box-shadow: 0 12px 30px -16px rgba(20, 24, 38, 0.25);
//         }

//         .av-fact {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           padding: 18px 20px;
//           min-width: 0;
//         }

//         .av-fact + .av-fact { border-left: 1px solid var(--av-border); }

//         .av-fact > i {
//           flex-shrink: 0;
//           width: 40px;
//           height: 40px;
//           border-radius: 12px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 19px;
//           color: var(--av-accent);
//           background: var(--av-accent-soft);
//         }

//         .av-fact > div { display: flex; flex-direction: column; min-width: 0; }

//         .av-fact-label {
//           font-size: 12px;
//           color: var(--av-muted);
//           font-weight: 500;
//         }

//         .av-fact-value {
//           font-size: 14.5px;
//           font-weight: 600;
//           color: var(--av-ink);
//           overflow-wrap: anywhere;
//         }

//         /* ---------- Body ---------- */
//         .av-body {
//           padding: 28px 40px 40px;
//           display: flex;
//           flex-direction: column;
//           gap: 24px;
//         }

//         .av-two-col {
//           display: grid;
//           grid-template-columns: repeat(2, minmax(0, 1fr));
//           gap: 24px;
//         }

//         .av-block {
//           background: var(--av-canvas);
//           border: 1px solid var(--av-border);
//           border-radius: 16px;
//           padding: 24px;
//         }

//         .av-section-head {
//           display: flex;
//           align-items: center;
//           gap: 14px;
//           margin-bottom: 20px;
//           padding-bottom: 16px;
//           border-bottom: 1px dashed #d9dcea;
//         }

//         .av-step {
//           flex-shrink: 0;
//           width: 44px;
//           height: 44px;
//           border-radius: 13px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: var(--av-accent);
//           color: #fff;
//           font-size: 21px;
//           box-shadow: 0 8px 16px -8px rgba(242, 101, 34, 0.7);
//         }

//         .av-section-title {
//           font-size: 16px;
//           font-weight: 700;
//           margin: 0;
//           color: var(--av-ink);
//         }

//         .av-section-subtitle {
//           margin: 2px 0 0;
//           font-size: 12.5px;
//           color: var(--av-muted);
//         }

//         /* ---------- Fields ---------- */
//         .av-grid { display: grid; gap: 12px; }
//         .av-grid-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
//         .av-grid-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
//         .av-span-2 { grid-column: span 2; }

//         .av-field {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           min-width: 0;
//           height: 100%;
//           padding: 12px 14px;
//           background: var(--av-paper);
//           border: 1px solid var(--av-border);
//           border-radius: 12px;
//         }

//         .av-field-icon {
//           flex-shrink: 0;
//           width: 34px;
//           height: 34px;
//           border-radius: 10px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 17px;
//           color: var(--av-accent);
//           background: var(--av-accent-soft);
//         }

//         .av-field-text { display: flex; flex-direction: column; min-width: 0; }

//         .av-field-label {
//           font-size: 12px;
//           font-weight: 500;
//           color: var(--av-muted);
//         }

//         .av-field-value {
//           font-size: 14px;
//           font-weight: 600;
//           color: var(--av-ink);
//           overflow-wrap: anywhere;
//         }

//         .av-address-note {
//           display: flex;
//           align-items: flex-start;
//           gap: 12px;
//           margin-bottom: 12px;
//           padding: 14px 16px;
//           border-radius: 12px;
//           background: var(--av-accent-soft);
//           border: 1px solid #f8d3bd;
//         }

//         .av-address-note i {
//           font-size: 20px;
//           color: var(--av-accent);
//           margin-top: 1px;
//         }

//         .av-address-note p {
//           margin: 0;
//           font-size: 14px;
//           font-weight: 500;
//           line-height: 1.5;
//           color: var(--av-ink);
//         }

//         /* ---------- Location ---------- */
//         .av-loc-grid {
//           display: grid;
//           grid-template-columns: repeat(2, minmax(0, 1fr));
//           gap: 20px;
//         }

//         .av-media-card {
//           background: var(--av-paper);
//           border: 1px solid var(--av-border);
//           border-radius: 14px;
//           padding: 14px;
//           display: flex;
//           flex-direction: column;
//         }

//         .av-media-head {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           margin-bottom: 12px;
//           font-size: 13.5px;
//           font-weight: 600;
//           color: var(--av-ink);
//         }

//         .av-media-head i { margin-right: 6px; color: var(--av-accent); }

//         .av-link {
//           font-size: 12.5px;
//           font-weight: 600;
//           color: var(--av-accent);
//           text-decoration: none;
//         }

//         .av-link:hover { color: var(--av-accent-dark); text-decoration: underline; }

//         .av-map-frame,
//         .av-selfie-frame {
//           position: relative;
//           border-radius: 10px;
//           overflow: hidden;
//           border: 1px solid var(--av-border);
//           height: 300px;
//         }

//         .av-selfie-frame { background: #0b0d14; }

//         .av-map-frame iframe {
//           width: 100%;
//           height: 100%;
//           border: 0;
//         }

//         .av-selfie-frame img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//         }

//         .av-live-tag {
//           position: absolute;
//           left: 12px;
//           bottom: 12px;
//           display: inline-flex;
//           align-items: center;
//           gap: 2px;
//           padding: 5px 12px 5px 8px;
//           border-radius: 999px;
//           font-size: 12px;
//           font-weight: 600;
//           color: #fff;
//           background: rgba(20, 24, 38, 0.72);
//         }

//         .av-live-tag i { color: #ff5c5c; font-size: 16px; }

//         .av-coords {
//           display: flex;
//           gap: 10px;
//           margin-top: 12px;
//           flex-wrap: wrap;
//         }

//         .av-coords span {
//           flex: 1;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 6px;
//           padding: 8px 10px;
//           font-size: 13px;
//           font-weight: 500;
//           color: var(--av-ink);
//           background: var(--av-canvas);
//           border: 1px solid var(--av-border);
//           border-radius: 999px;
//         }

//         .av-coords i { color: var(--av-accent); }

//         /* ---------- Documents ---------- */
//         .av-doc-grid {
//           display: grid;
//           grid-template-columns: repeat(4, minmax(0, 1fr));
//           gap: 16px;
//         }

//         .av-doc-card {
//           display: flex;
//           flex-direction: column;
//           background: var(--av-paper);
//           border: 1px solid var(--av-border);
//           border-radius: 14px;
//           overflow: hidden;
//           text-decoration: none;
//           color: inherit;
//           transition: border-color 0.15s ease, box-shadow 0.15s ease;
//         }

//         .av-doc-card:hover {
//           border-color: var(--av-accent);
//           box-shadow: 0 14px 28px -18px rgba(242, 101, 34, 0.55);
//         }

//         .av-doc-card:focus-visible {
//           outline: 2px solid var(--av-accent);
//           outline-offset: 2px;
//         }

//         .av-doc-thumb {
//           position: relative;
//           height: 170px;
//           background: #eceef5;
//           overflow: hidden;
//         }

//         .av-doc-img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//           transition: transform 0.25s ease;
//         }

//         .av-doc-card:hover .av-doc-img { transform: scale(1.05); }

//         .av-doc-overlay {
//           position: absolute;
//           inset: 0;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: rgba(20, 24, 38, 0.45);
//           opacity: 0;
//           transition: opacity 0.15s ease;
//         }

//         .av-doc-card:hover .av-doc-overlay,
//         .av-doc-card:focus-visible .av-doc-overlay { opacity: 1; }

//         .av-doc-view {
//           display: inline-flex;
//           align-items: center;
//           gap: 6px;
//           padding: 8px 16px;
//           border-radius: 999px;
//           font-size: 13px;
//           font-weight: 600;
//           color: var(--av-ink);
//           background: #fff;
//         }

//         .av-doc-meta {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           padding: 12px 14px;
//         }

//         .av-doc-icon {
//           flex-shrink: 0;
//           width: 34px;
//           height: 34px;
//           border-radius: 10px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 17px;
//           color: var(--av-accent);
//           background: var(--av-accent-soft);
//         }

//         .av-doc-text {
//           display: flex;
//           flex-direction: column;
//           min-width: 0;
//           flex: 1;
//         }

//         .av-doc-name {
//           font-size: 14px;
//           font-weight: 600;
//           color: var(--av-ink);
//         }

//         .av-doc-hint {
//           font-size: 12px;
//           color: var(--av-muted);
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .av-doc-ext { color: var(--av-muted); font-size: 16px; }
//         .av-doc-card:hover .av-doc-ext { color: var(--av-accent); }

//         /* ---------- Responsive ---------- */
//         @media (max-width: 1100px) {
//           .av-two-col { grid-template-columns: 1fr; }
//           .av-facts { grid-template-columns: repeat(2, 1fr); }
//           .av-fact:nth-child(3) { border-left: 0; }
//           .av-fact:nth-child(n + 3) { border-top: 1px solid var(--av-border); }
//           .av-doc-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
//         }

//         @media (max-width: 720px) {
//           .av-hero { flex-direction: column; align-items: flex-start; padding: 24px 20px 60px; }
//           .av-hero-main { flex-direction: column; align-items: flex-start; }
//           .av-title { font-size: 22px; }
//           .av-facts { margin: -36px 16px 0; grid-template-columns: 1fr; }
//           .av-fact + .av-fact { border-left: 0; border-top: 1px solid var(--av-border); }
//           .av-body { padding: 20px 16px 28px; }
//           .av-block { padding: 18px; }
//           .av-grid-2, .av-grid-3, .av-loc-grid { grid-template-columns: 1fr; }
//           .av-span-2 { grid-column: auto; }
//           .av-doc-grid { grid-template-columns: 1fr; }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default AddressSubmittedForm;


import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useApi from "../../../core/customhook/useApi";
import SnipperLoader from "../../../core/common/loader/SnipperLoader";
import { apibaseurl, getPersonalDetails } from "../../../environment";

/* ----------------------------------------------------------------------- */
/*  Small building blocks                                                   */
/* ----------------------------------------------------------------------- */

const Field: React.FC<{ icon?: string; label: string; value?: string }> = ({
  icon,
  label,
  value,
}) =>
  !value ? null : (
    <div className="av-field">
      <span className="av-field-label">
        {icon && <i className={`ti ${icon} me-1`}></i>}
        {label}
      </span>
      <span className="av-field-value">{value}</span>
    </div>
  );

const SectionHeader: React.FC<{
  icon: string;
  step: number;
  title: string;
  subtitle?: string;
}> = ({ icon, step, title, subtitle }) => (
  <div className="av-section-head">
    <div className="av-step">
      <i className={`ti ${icon}`}></i>
      <span className="av-step-index">{String(step).padStart(2, "0")}</span>
    </div>
    <div>
      <h3 className="av-section-title">{title}</h3>
      {subtitle && <p className="av-section-subtitle">{subtitle}</p>}
    </div>
  </div>
);

const AddressSubmittedForm: React.FC = () => {
  const reduxDashboardData = useSelector(
    (state: any) => state?.dashboard?.dashboardData,
  );

  const candidateId = reduxDashboardData?.assignmentDetails?.candidate_id;

  const getAddressAPI = useApi<any>(
    `/api/v1/candidates/addresses/${candidateId}`,
    {
      method: "GET",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const PersonalDetailAPI = useApi<any>(getPersonalDetails, {
    method: "GET",
    autoCall: false,
    handleGlobalError: false,
  });

  const [summaryData, setSummaryData] = useState<any>(null);
  const [personalData, setPersonalData] = useState<any>(null);

  const fetchDetails = async () => {
    try {
      const res = await getAddressAPI.callApi();

      if (!res?.success) return;
      setSummaryData(res.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPersonalDetails = async () => {
    try {
      const res = await PersonalDetailAPI.callApi();

      if (!res?.success) return;
      setPersonalData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (candidateId) {
      fetchDetails();
    }
    fetchPersonalDetails();
  }, [candidateId]);

  const mapSrc = `https://maps.google.com/maps?q=${summaryData?.address_latitude},${summaryData?.address_longitude}&z=15&output=embed`;

  const live_selfie_url = `${apibaseurl}${summaryData?.live_selfie_url}`;
  const id_proof_photo = `${apibaseurl}${summaryData?.id_proof_photo}`;
  const address_proof_photo = `${apibaseurl}${summaryData?.address_proof_photo}`;
  const house_photo = `${apibaseurl}${summaryData?.house_photo}`;
  const locality_photo = `${apibaseurl}${summaryData?.locality_photo}`;

  const loading = getAddressAPI.loading;
  return (
    <div className="page-wrapper">
      <div className="content">
        {loading ? (
          <SnipperLoader />
        ) : (
          <div className="card overflow-hidden av-card">
            {/* Header */}
            <div className="av-header">
              <div className="av-header-text text-center">
                <span className="av-eyebrow">
                  <i className="ti ti-shield-check me-1"></i>
                  Verification Report
                </span>
                <h2 className="av-title">Address Verification Summary</h2>
              </div>
            </div>

            <div className="av-body">
              {/* 1. Personal Details */}
              <section className="av-section">
                <SectionHeader
                  icon="ti-user"
                  step={1}
                  title="Personal Details"
                  subtitle="Identity information as submitted"
                />
                <div className="av-panel">
                  <div className="av-grid av-grid-3">
                    <Field
                      label="First Name"
                      value={personalData?.first_name || "-"}
                    />
                    <Field
                      label="Middle Name"
                      value={personalData?.middle_name || "-"}
                    />
                    <Field
                      label="Last Name"
                      value={personalData?.last_name || "-"}
                    />
                    <Field
                      icon="ti-cake"
                      label="Date of Birth"
                      value={
                        personalData?.dob
                          ? new Date(personalData.dob).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              },
                            )
                          : "-"
                      }
                    />
                    <Field
                      icon="ti-gender-bigender"
                      label="Gender"
                      value={personalData?.gender || "-"}
                    />
                    <Field
                      icon="ti-users"
                      label="Father's or Mother Name"
                      value={personalData?.father_or_mother_name || "-"}
                    />
                    <Field
                      icon="ti-phone"
                      label="Mobile"
                      value={personalData?.phone || "-"}
                    />
                    <Field
                      icon="ti-phone-plus"
                      label="Alternate Mobile"
                      value={personalData?.alternative_phone || "-"}
                    />
                    <Field
                      icon="ti-mail"
                      label="Email"
                      value={personalData?.email || "-"}
                    />
                  </div>
                </div>
              </section>

              {/* 2. Address Details */}
              <section className="av-section">
                <SectionHeader
                  icon="ti-map-pin"
                  step={2}
                  title="Address Details"
                  subtitle="Registered residential address"
                />
                <div className="av-panel">
                  <div className="av-grid av-grid-4">
                    <Field
                      label="Address Type"
                      value={summaryData?.address_type}
                    />
                    <Field label="Pincode" value={summaryData?.pincode} />
                    <Field label="City" value={summaryData?.city} />
                    <Field label="State" value={summaryData?.state} />
                    <Field label="Country" value={summaryData?.country} />
                    <Field
                      label="House No."
                      value={summaryData?.address_line1}
                    />
                    <Field
                      label="Apartment"
                      value={summaryData?.address_line2}
                    />
                    <Field
                      label="Landmark"
                      value={summaryData?.address_line3}
                    />
                  </div>
                </div>
              </section>

              {/* 3. Location + Selfie */}
              <section className="av-section">
                <SectionHeader
                  icon="ti-map-2"
                  step={3}
                  title="Location & Live Selfie Verification"
                  subtitle="Geo-tagged coordinates captured during visit"
                />
                <div className="row av-loc-row">
                  <div className="col-md-6">
                    <div className="av-panel av-map-panel">
                      <div className="av-panel-label">
                        <i className="ti ti-map me-1"></i> Google Map
                      </div>
                      <div className="av-map-frame">
                        <iframe
                          title="location-map"
                          src={mapSrc}
                          loading="lazy"
                          allowFullScreen
                        />
                      </div>
                      <div className="av-coords">
                        <span>
                          <i className="ti ti-map-pin me-1"></i> Lat:{" "}
                          {summaryData?.address_latitude}
                        </span>
                        <span>
                          <i className="ti ti-map-pin me-1"></i> Long:{" "}
                          {summaryData?.address_longitude}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="av-panel av-selfie-panel">
                      <div className="av-panel-label">
                        <i className="ti ti-camera-selfie me-1"></i> Live Selfie
                      </div>
                      <div className="av-selfie-frame">
                        <img
                          src={live_selfie_url}
                          alt="Live selfie verification"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* 4. Stay Verification */}
              <section className="av-section">
                <SectionHeader
                  icon="ti-home"
                  step={4}
                  title="Stay Verification"
                  subtitle="Confirmed by an on-ground verifier"
                />
                <div className="av-panel">
                  <div className="av-grid av-grid-3">
                    <Field
                      icon="ti-user-check"
                      label="Verifier Name"
                      value={summaryData?.verifier_full_name}
                    />
                    <Field
                      icon="ti-users-group"
                      label="Verifier Relationship"
                      value={summaryData?.verifier_relationship}
                    />
                    <Field
                      icon="ti-map-pin-cog"
                      label="Nearest Landmark"
                      value={summaryData?.verifier_addrlandmark}
                    />
                    <Field
                      icon="ti-building-community"
                      label="Nature of Address"
                      value={summaryData?.address_type}
                    />
                    <Field
                      icon="ti-calendar-time"
                      label="Period of Stay"
                      value={`${summaryData?.period_of_stay}, ${summaryData?.period_of_stay_param}`}
                    />
                    <Field
                      icon="ti-key"
                      label="Ownership Status"
                      value={summaryData?.ownership_status}
                    />
                  </div>
                </div>
              </section>

              {/* 5. Uploaded Documents */}
              <section className="av-section av-section-last">
                <SectionHeader
                  icon="ti-folder"
                  step={5}
                  title="Uploaded Documents"
                />
                <div className="av-doc-grid">
                  <a
                    className="av-doc-card"
                    href={id_proof_photo}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={id_proof_photo}
                      alt={"Document"}
                      className="av-doc-img"
                    />
                    <span className="av-doc-overlay">
                      <span className="av-doc-view">
                        <i className="ti ti-eye me-1"></i> View
                      </span>
                    </span>
                  </a>
                  <a
                    className="av-doc-card"
                    href={address_proof_photo}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={address_proof_photo}
                      alt={"Document"}
                      className="av-doc-img"
                    />
                    <span className="av-doc-overlay">
                      <span className="av-doc-view">
                        <i className="ti ti-eye me-1"></i> View
                      </span>
                    </span>
                  </a>
                  <a
                    className="av-doc-card"
                    href={house_photo}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={house_photo}
                      alt={"Document"}
                      className="av-doc-img"
                    />
                    <span className="av-doc-overlay">
                      <span className="av-doc-view">
                        <i className="ti ti-eye me-1"></i> View
                      </span>
                    </span>
                  </a>
                  <a
                    className="av-doc-card"
                    href={locality_photo}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={locality_photo}
                      alt={"Document"}
                      className="av-doc-img"
                    />
                    <span className="av-doc-overlay">
                      <span className="av-doc-view">
                        <i className="ti ti-eye me-1"></i> View
                      </span>
                    </span>
                  </a>
                </div>
              </section>
            </div>
          </div>
        )}
      </div>

      <style>{`
        .av-card {
          --av-ink: #101425;
          --av-muted: #6b7280;
          --av-faint: #101425;
          --av-paper: #ffffff;
          --av-canvas: #f6f7fb;
          --av-border: #e8eaf2;
          --av-accent: #F26522;
          --av-accent-soft: #fae9e0;
          --av-success: #0f9d63;
          --av-success-soft: #e7f8f0;
          font-family: 'Inter', -apple-system, sans-serif;
          color: var(--av-ink);
          background: var(--av-paper);
          border: 1px solid var(--av-border);
          border-radius: 20px;
          box-shadow: 0 1px 2px rgba(16, 20, 37, 0.04), 0 12px 32px -16px rgba(16, 20, 37, 0.12);
        }

        .av-header {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 24px;
          padding: 25px 36px 25px;
          border-bottom: 1px solid var(--av-border);
        }

        .av-eyebrow {
          display: inline-flex;
          align-items: center;
           justify-content: center;

          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: var(--av-accent);
          margin-bottom: 10px;
        }

        .av-title {
          font-size: 24px;
          font-weight: 700;
          margin: 0 0 6px;
          color: var(--av-ink);
        }

        .av-subtitle {
          margin: 0;
          font-size: 14px;
          color: var(--av-muted);
        }

        .av-subtitle strong {
          color: var(--av-ink);
          font-weight: 600;
        }

        .av-body {
          padding: 8px 36px 36px;
        }

        .av-section {
          position: relative;
          padding: 28px 0 0;
        }

        .av-section:not(:last-child)::after {
          content: '';
          position: absolute;
          left: 21px;
          top: 62px;
          bottom: -6px;
          width: 1px;
          background: var(--av-border);
        }

        .av-section-last:not(:last-child)::after {
          display: none;
        }

        .av-section-head {
          display: flex;
          align-items: flex-start;
          gap: 16px;
          margin-bottom: 16px;
        }

        .av-step {
          position: relative;
          flex-shrink: 0;
          width: 44px;
          height: 44px;
          border-radius: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--av-accent-soft);
          color: var(--av-accent);
          font-size: 20px;
          z-index: 1;
        }

        .av-step-index {
          position: absolute;
          bottom: -6px;
          right: -6px;
          background: var(--av-paper);
          border: 1px solid var(--av-border);
          color: var(--av-faint);
          font-size: 9px;
          font-weight: 700;
          padding: 1px 5px;
          border-radius: 999px;
        }

        .av-section-title {
          font-size: 15.5px;
          font-weight: 600;
          margin: 2px 0 2px;
          color: var(--av-ink);
        }

        .av-section-subtitle {
          margin: 0;
          font-size: 12.5px;
          color: var(--av-muted);
        }

        .av-panel {
          margin-left: 45px;
          background: var(--av-canvas);
          border: 1px solid var(--av-border);
          border-radius: 14px;
          padding: 20px 20px;
        }

        .av-grid {
          display: grid;
          gap: 18px 24px;
        }

        .av-grid-3 { grid-template-columns: repeat(3, 1fr); }
        .av-grid-4 { grid-template-columns: repeat(4, 1fr); }

        .av-field {
          display: flex;
          flex-direction: column;
          gap: 4px;
          min-width: 0;
        }

        .av-field-label {
          font-size: 14px;
          font-weight: 700;
          color: var(--av-faint);
          text-transform: uppercase;
          letter-spacing: 0.04em;
          display: flex;
          align-items: center;
        }

        .av-field-value {
          font-size: 14px;
          font-weight: 500;
          color: var(--av-ink);
          overflow-wrap: anywhere;
        }

        .av-loc-row {
         
          margin-right: 0;
          --bs-gutter-x: 20px;
        }

        .av-map-panel, .av-selfie-panel {
          height: 100%;
        }

        .av-panel-label {
          display: flex;
          align-items: center;
          font-size: 12.5px;
          font-weight: 600;
          color: var(--av-ink);
          margin-bottom: 12px;
        }

        .av-map-frame {
          border-radius: 10px;
          overflow: hidden;
          border: 1px solid var(--av-border);
          height: 280px;
        }

        .av-map-frame iframe {
          width: 100%;
          height: 100%;
          border: 0;
        }

        .av-coords {
         display: flex;
   
    justify-content: space-around;
    margin-top: 12px;
    font-size: 13px;
    color: var(--av-faint);
    align-items: center;
        }

        .av-coords span {
              display: flex;
    align-items: center;
    background: #ffff;
    padding: 0.5rem;
    border-radius: 1rem;
        }

        .av-selfie-frame {
          position: relative;
          border-radius: 10px;
          overflow: hidden;
          border: 1px solid var(--av-border);
          height: 280px;
          background: #0b0d14;
        }

        .av-selfie-frame img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .av-doc-grid {
          margin-left: 60px;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 16px;
        }

        .av-doc-card {
          position: relative;
          display: block;
          height: 150px;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid var(--av-border);
          text-decoration: none;
        }

        .av-doc-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.2s ease;
        }

        .av-doc-card:hover .av-doc-img {
          transform: scale(1.04);
        }

        .av-doc-overlay {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 10px 12px;
        //   background: linear-gradient(180deg, rgba(16,20,37,0.55) 0%, rgba(16,20,37,0) 30%, rgba(16,20,37,0) 60%, rgba(16,20,37,0.65) 100%);
        }

        .av-doc-caption {
          align-self: flex-start;
          font-size: 11px;
          font-weight: 600;
          color: #fff;
          background: rgba(16, 20, 37, 0.45);
          padding: 3px 9px;
          border-radius: 999px;
        }

        .av-doc-view {
          align-self: flex-end;
          display: flex;
          align-items: center;
          font-size: 11.5px;
          font-weight: 600;
          color: #000;
          opacity: 0;
          transform: translateY(4px);
          transition: opacity 0.15s ease, transform 0.15s ease;
        }

        .av-doc-card:hover .av-doc-view {
          opacity: 1;
          transform: translateY(0);
        }

        @media (max-width: 900px) {
          .av-grid-3, .av-grid-4 { grid-template-columns: repeat(2, 1fr); }
          .av-doc-grid { grid-template-columns: repeat(2, 1fr); }
        }

        @media (max-width: 640px) {
          .av-header { flex-direction: column; padding: 24px; }
          .av-body { padding: 8px 20px 28px; }
          .av-panel, .av-loc-row, .av-doc-grid { margin-left: 0; }
          .av-grid-3, .av-grid-4 { grid-template-columns: 1fr; }
          .av-doc-grid { grid-template-columns: repeat(2, 1fr); }
          .av-section:not(:last-child)::after { display: none; }
        }
      `}</style>
    </div>
  );
};

export default AddressSubmittedForm;
